module.exports = __webpack_public_path__ + "img/headM.dee2e8df.png";